import { CallToActionType, MapstrCtaButtonType } from ':modules/posts/social-posts.interface';

export enum SeoPostsListStatusFilter {
    ALL = 'ALL',
    DRAFT = 'DRAFT',
    ERROR = 'ERROR',
    FEEDBACK = 'FEEDBACK',
}

export const postCallToActionTypeValues = Array.from(new Set([...Object.values(MapstrCtaButtonType), ...Object.values(CallToActionType)]));
export type PostCallToActionType = (typeof postCallToActionTypeValues)[number];
export interface PostCallToAction {
    actionType: PostCallToActionType;
    url: string;
}

export interface SeoPostCallToAction {
    actionType: CallToActionType;
    url: string;
}
